var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUturncircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1358_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 19.9219C15.4102 19.9219 19.9219 15.4004 19.9219 9.96094C19.9219 4.51172 15.4004 0 9.95117 0C4.51172 0 0 4.51172 0 9.96094C0 15.4004 4.52148 19.9219 9.96094 19.9219ZM9.96094 18.2617C5.35156 18.2617 1.66992 14.5703 1.66992 9.96094C1.66992 5.35156 5.3418 1.66016 9.95117 1.66016C14.5605 1.66016 18.2617 5.35156 18.2617 9.96094C18.2617 14.5703 14.5703 18.2617 9.96094 18.2617Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.1523C15 8.80859 13.3008 7.38281 11.0254 7.38281H8.10547L6.95312 7.41211L7.72461 6.80664L8.73047 5.83008C8.86719 5.71289 8.95508 5.52734 8.95508 5.32227C8.95508 4.92188 8.65234 4.61914 8.25195 4.61914C8.04688 4.61914 7.89062 4.67773 7.75391 4.82422L5.15625 7.46094C5 7.62695 4.89258 7.83203 4.89258 8.05664C4.89258 8.29102 5 8.48633 5.15625 8.65234L7.76367 11.3086C7.90039 11.4453 8.05664 11.5137 8.26172 11.5137C8.65234 11.5137 8.95508 11.2109 8.95508 10.8008C8.95508 10.625 8.88672 10.4297 8.74023 10.3027L7.51953 9.13086L6.95312 8.70117L8.10547 8.75H11.0254C12.4609 8.75 13.5645 9.57031 13.5645 11.0742C13.5645 12.6172 12.4902 13.5645 11.0156 13.5645C10.8984 13.5645 9.69727 13.5645 9.6582 13.5645C9.23828 13.5645 8.91602 13.8086 8.91602 14.2676C8.91602 14.7168 9.23828 14.9609 9.67773 14.9609C9.72656 14.9609 10.8984 14.9609 11.0156 14.9609C13.291 14.9609 15 13.4961 15 11.1523Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1358_1712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2832,
    height: 19.9316,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUturncircle);
export default __webpack_public_path__ + "static/media/uturn.circle.f8a355399d54b76a13b3e2d12cb9e55d.svg";
export { ForwardRef as ReactComponent };